import IndexSelector from "./IndexSelector.js";
import KeySelector from "./KeySelector.js";
import SingleSelector from "./SingleSelector.js";
import MultiSelector from "./MultiSelector.js";
export { IndexSelector, KeySelector, SingleSelector, MultiSelector };

// For backward compatibility
export default {
  IndexSelector,
  KeySelector,
  SingleSelector,
  MultiSelector
};